// components.application.integrations.connectedIntegration

export const CONNECTED_INTEGRATION = {
  tooltips: {
    connected: 'Connected',
    notConnected: 'Not Connected',
    delete: 'Delete'
  }
};
